var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('apex-chart',{ref:"chart",attrs:{"height":"175","type":"bar","options":_vm.chartOptions,"series":_vm.series}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }